require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./health-assessment-and-treatment-team.json") })
        }
      }, "path---health-assessment-and-treatment-team");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---health-assessment-and-treatment-team!./.cache/json/health-assessment-and-treatment-team.json
// module id = 901
// module chunks = 231608221292675